/*
    filter 邏輯
    1. init(is_first=true) =>
        1. query_to_filter
        2. fetch_core_waybills
            1. filter_to_api_query
            2. axios
        if (is_first) {
            3. handle_quick_filter_key ui 決定要顯示哪個filter 樣式
        }
    2. filter() =>
        1. filter_to_query
        2. routes.push() 觸發 watch_routes()

    3. watch_routes() =>
        1. init(false)
 */

import ResponseError from '@javascripts/response_error.js'
import moment from "moment"
const store = {
    namespaced: true,
    state: {
        pagination: {
            current_page: null,
            total_pages: null,
        },
        filter: {
            is_advanced_mode: false,
            shortcut_keys: [
                "loggable_type", "staff_name", "title", "action_type", "created_duration"
            ],
            current_shortcut_key: "staff_name",
            init_columns: {
                page: 1,
                loggable_type: null,
                staff_name: null,
                title: null,
                action_type: null,
                created_duration: null,
                begin_at: null,
                end_at: null,
            },
            columns: {}
        },
        user_logs: []
    },
    getters: {
        // filter 平面化 輸出一層object
        filter_to_query(state, getters, rootState, rootGetters) {
            let columns = _.cloneDeep(state.filter.columns)
            if (columns.page) delete columns.page
            if (columns.created_duration) {
                if (columns.created_duration[0]) columns.begin_at = moment(columns.created_duration[0]).format("YYYY-MM-DD")
                if (columns.created_duration[1]) columns.end_at = moment(columns.created_duration[1]).format("YYYY-MM-DD")
                delete columns.created_duration
            }
            return object_delete_null(columns)
        },
        filter_to_api_query(state, getters, rootState, rootGetters) {
            return (payload) => {
                let columns = _.cloneDeep(state.filter.columns)
                if (columns.created_duration) {
                    if (columns.created_duration[0]) columns.begin_at = date_to_start(columns.created_duration[0])
                    if (columns.created_duration[1]) columns.end_at = date_to_end(columns.created_duration[1])
                    delete columns.created_duration
                }
                return object_to_query(columns)
            }
        },
    },
    actions: {
        fetch_user_logs(context, payload) {
            let url = new RestUrl(context.rootState.provider.routes.api_v1_provider_logs).parse(
                {},
                ""
            )
            let api_query = context.getters.filter_to_api_query()
            if (api_query) url += `?${api_query}`

            console.log(url);
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_user_logs', response.data.logs)
                        context.commit('set_pagination', response.data.pagination)
                    } else if (response.data.status == 'failure') {
                        return Promise.reject('fetch_user_logs_failure')
                    }
                })
                .catch(error => {
                    return Promise.reject(
                        ResponseError(error)
                    )
                })
        },
        // query 轉成 filter格式 並 merge 到 filter
        handle_query_to_filter(context, payload = {}) {
            if (payload.query) {
                let query = {..._.cloneDeep(context.state.filter.init_columns), ...payload.query}
                if (query.begin_at && query.end_at) {
                    query.created_duration = [
                        moment(query.begin_at) || "",
                        moment(query.end_at) || ""
                    ]
                    delete query.begin_at
                    delete query.end_at
                }
                context.state.filter.columns = {...context.state.filter.columns, ...query}
            }
        },
        // only run in init()
        handle_quick_filter_key(context, payload = {}) {
            let columns = object_delete_null(
                _.cloneDeep(context.state.filter.columns)
            )

            if (columns.page) delete columns.page

            let shortcut_key_occurrence_number = {
                number: 0,
                number_last_key: "",
            }

            context.state.filter.shortcut_keys.forEach((key) => {
                if(columns[key]) {
                    shortcut_key_occurrence_number.number += 1
                    shortcut_key_occurrence_number.number_last_key = key
                }
            })

            if (shortcut_key_occurrence_number.number == 1) {
                context.state.filter.current_shortcut_key =
                    shortcut_key_occurrence_number.number_last_key
            }

            if (
                (
                    shortcut_key_occurrence_number.number == 0 &&
                    Object.keys(columns).length >= 1
                ) || (
                    shortcut_key_occurrence_number.number >= 2
                )
            ) {
                context.state.filter.is_advanced_mode = true
            }
        },
    },
    mutations: {
        set_user_logs(state, payload) {
            state.user_logs = payload
        },
        set_pagination(state, payload) {
            state.pagination = payload
        },
        init_filter_columns(state, payload) {
            state.filter.columns = _.cloneDeep(state.filter.init_columns)
        }
    }
}

export default store
